"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionToolbar = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CloseDialogIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseDialogIcon"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const useSelection_1 = __importDefault(require("../useSelection"));
const useSelectionActions_1 = __importDefault(require("../useSelectionActions"));
const makeMyClasses = () => ({
    root: {
        minHeight: 36,
        minWidth: 44,
        margin: '0 4px 0 0',
        padding: 0,
        '& .MuiButton-label>div': {
            display: 'flex',
            justifyContent: 'center',
        },
        '& .labelText': {
            transition: 'font 0.3s',
            height: 0,
            fontSize: 0,
            position: 'absolute',
            top: 6,
        },
        '& .labelIcon .SVGIconRoot': {
            transition: 'width 0.3s, height 0.3s, margin 0.3s',
            marginTop: 0,
        },
        '& .labelIcon svg': {
            transition: 'width 0.3s, height 0.3s',
        },
        '&:hover .labelText': {
            height: 14,
            fontSize: 12,
        },
        '&:hover .labelIcon .SVGIconRoot': {
            width: '12px !important',
            height: '12px !important',
            marginTop: 18,
        },
        '&:hover .labelIcon svg': { width: '0.4em !important', height: '0.4em !important' },
    },
    rootLabelOnly: {
        minHeight: 36,
        minWidth: 44,
        margin: '0 4px 0 0',
    },
});
function SelectionToolbar(props) {
    const { dataType, actions = [] } = props;
    const { selecteds } = (0, useSelection_1.default)(dataType);
    const { clearSelection } = (0, useSelectionActions_1.default)(dataType);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", null,
        react_1.default.createElement(Button_1.default, { background: true, onClick: clearSelection, iconRight: react_1.default.createElement(CloseDialogIcon_1.default, null), margin: "0 4px 0 0", minLabelWidth: 120 }, lib_i18n_1.default.t('item-selected', { count: selecteds.length })),
        actions
            .filter(action => !action.hidden)
            .map((action, idx) => (react_1.default.createElement(SelectionButton, { key: `action${idx}`, action: action }))))), [actions, clearSelection, selecteds.length]);
}
exports.SelectionToolbar = SelectionToolbar;
exports.default = SelectionToolbar;
function SelectionButton({ action }) {
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const labelOnly = action.label && !action.Icon;
    const icon = labelOnly ? undefined : react_1.default.createElement(action.Icon, null);
    return (react_1.default.createElement(Button_1.default, { tooltip: action.label, classes: { root: labelOnly ? myCss.rootLabelOnly : myCss.root }, label: action.label, color: action.color, disabled: action.disabled, onClick: action.onClick, iconAbove: icon, small: true }));
}
